export const AUTH_TOKEN = "@pm-admin/auth_token"